<aside class="panel" *ngIf="selection as active">
  <header class="panel-header">
    <div class="panel-title">
      <span *ngIf="active.kind === 'antenna'">{{ i18n.translate('coverage.panel.antenna') }}</span>
      <span *ngIf="active.kind === 'obstacle'">{{ i18n.translate('coverage.panel.obstacle') }}</span>
    </div>
    <button type="button" class="panel-close" (click)="close.emit()" [attr.aria-label]="i18n.translate('coverage.panel.close')">✕</button>
  </header>

  <ng-container [ngSwitch]="active.kind">
    <ng-container *ngSwitchCase="'antenna'">
      <ng-container *ngIf="selectedAntenna as ap; else invalidSelection">
        <div class="panel-row"><span>{{ i18n.translate('coverage.panel.power') }}</span><strong>{{ ap.power }} dBm</strong></div>
        <div class="panel-row"><span>{{ i18n.translate('coverage.panel.sigma') }}</span><strong>{{ ap.sigma }}</strong></div>
        <div class="panel-row"><span>{{ i18n.translate('coverage.panel.length') }}</span><strong>{{ antennaLength() | number: '1.0-0' }} px</strong></div>
        <div class="panel-row">
          <span>{{ i18n.translate('coverage.panel.height') }}</span>
          <input
            type="number"
            min="1"
            max="15"
            step="0.5"
            [value]="ap.height ?? 7"
            (input)="onAntennaHeightInput($event)"
          />
        </div>
        <div class="panel-row">
          <button type="button" class="danger" (click)="requestDeleteAntenna()">{{ i18n.translate('coverage.panel.deleteAntenna') }}</button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'obstacle'">
      <ng-container *ngIf="selectedObstacle as ob; else invalidSelection">
        <div class="panel-row">
          <span>{{ i18n.translate('coverage.panel.material') }}</span>
          <select [value]="ob.material" (change)="onObstacleMaterialSelect($event)">
            <option *ngFor="let mat of obstacleMaterials" [value]="mat.value">{{ i18n.translate(mat.labelKey) }}</option>
          </select>
        </div>
        <div class="panel-row">
          <span>{{ i18n.translate('coverage.panel.loss') }}</span>
          <input
            type="number"
            min="0"
            max="30"
            step="0.5"
            [value]="ob.loss"
            (input)="onObstacleLossInput($event)"
          />
        </div>
        <div class="panel-row">
          <span>{{ i18n.translate('coverage.panel.thickness') }}</span>
          <input
            type="number"
            min="5"
            max="80"
            step="1"
            [value]="ob.thickness ?? 30"
            (input)="onObstacleThicknessInput($event)"
          />
        </div>
        <div class="panel-row">
          <span>{{ i18n.translate('coverage.panel.height') }}</span>
          <input
            type="number"
            min="1"
            max="6"
            step="0.1"
            [value]="ob.height"
            (input)="onObstacleHeightInput($event)"
          />
        </div>
        <div class="panel-row"><span>{{ i18n.translate('coverage.panel.length') }}</span><strong>{{ obstacleLength() | number: '1.0-0' }} px</strong></div>
        <div class="panel-row">
          <button type="button" class="danger" (click)="requestDeleteObstacle()">{{ i18n.translate('coverage.panel.deleteObstacle') }}</button>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-template [ngTemplateOutlet]="invalidSelection"></ng-template>
    </ng-container>
  </ng-container>

  <ng-template #invalidSelection>
    <p class="panel-empty">{{ i18n.translate('coverage.panel.invalidSelection') }}</p>
  </ng-template>
</aside>
